function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import Delta from 'quill-delta';
import Quill from '../core/quill.js';
import Module from '../core/module.js';
import { TableCell, TableRow, TableBody, TableContainer, tableId } from '../formats/table.js';

var Table =
/*#__PURE__*/
function (_Module) {
  _inherits(Table, _Module);

  _createClass(Table, null, [{
    key: "register",
    value: function register() {
      Quill.register(TableCell);
      Quill.register(TableRow);
      Quill.register(TableBody);
      Quill.register(TableContainer);
    }
  }]);

  function Table() {
    var _this;

    _classCallCheck(this, Table);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Table).apply(this, arguments));

    _this.listenBalanceCells();

    return _this;
  }

  _createClass(Table, [{
    key: "balanceTables",
    value: function balanceTables() {
      this.quill.scroll.descendants(TableContainer).forEach(function (table) {
        table.balanceCells();
      });
    }
  }, {
    key: "deleteColumn",
    value: function deleteColumn() {
      var _this$getTable = this.getTable(),
          _this$getTable2 = _slicedToArray(_this$getTable, 3),
          table = _this$getTable2[0],
          cell = _this$getTable2[2];

      if (cell == null) return; // @ts-expect-error

      table.deleteColumn(cell.cellOffset());
      this.quill.update(Quill.sources.USER);
    }
  }, {
    key: "deleteRow",
    value: function deleteRow() {
      var _this$getTable3 = this.getTable(),
          _this$getTable4 = _slicedToArray(_this$getTable3, 2),
          row = _this$getTable4[1];

      if (row == null) return;
      row.remove();
      this.quill.update(Quill.sources.USER);
    }
  }, {
    key: "deleteTable",
    value: function deleteTable() {
      var _this$getTable5 = this.getTable(),
          _this$getTable6 = _slicedToArray(_this$getTable5, 1),
          table = _this$getTable6[0];

      if (table == null) return; // @ts-expect-error

      var offset = table.offset(); // @ts-expect-error

      table.remove();
      this.quill.update(Quill.sources.USER);
      this.quill.setSelection(offset, Quill.sources.SILENT);
    }
  }, {
    key: "getTable",
    value: function getTable() {
      var range = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.quill.getSelection();
      if (range == null) return [null, null, null, -1];

      var _this$quill$getLine = this.quill.getLine(range.index),
          _this$quill$getLine2 = _slicedToArray(_this$quill$getLine, 2),
          cell = _this$quill$getLine2[0],
          offset = _this$quill$getLine2[1];

      if (cell == null || cell.statics.blotName !== TableCell.blotName) {
        return [null, null, null, -1];
      }

      var row = cell.parent;
      var table = row.parent.parent; // @ts-expect-error

      return [table, row, cell, offset];
    }
  }, {
    key: "insertColumn",
    value: function insertColumn(offset) {
      var range = this.quill.getSelection();
      if (!range) return;

      var _this$getTable7 = this.getTable(range),
          _this$getTable8 = _slicedToArray(_this$getTable7, 3),
          table = _this$getTable8[0],
          row = _this$getTable8[1],
          cell = _this$getTable8[2];

      if (cell == null) return;
      var column = cell.cellOffset();
      table.insertColumn(column + offset);
      this.quill.update(Quill.sources.USER);
      var shift = row.rowOffset();

      if (offset === 0) {
        shift += 1;
      }

      this.quill.setSelection(range.index + shift, range.length, Quill.sources.SILENT);
    }
  }, {
    key: "insertColumnLeft",
    value: function insertColumnLeft() {
      this.insertColumn(0);
    }
  }, {
    key: "insertColumnRight",
    value: function insertColumnRight() {
      this.insertColumn(1);
    }
  }, {
    key: "insertRow",
    value: function insertRow(offset) {
      var range = this.quill.getSelection();
      if (!range) return;

      var _this$getTable9 = this.getTable(range),
          _this$getTable10 = _slicedToArray(_this$getTable9, 3),
          table = _this$getTable10[0],
          row = _this$getTable10[1],
          cell = _this$getTable10[2];

      if (cell == null) return;
      var index = row.rowOffset();
      table.insertRow(index + offset);
      this.quill.update(Quill.sources.USER);

      if (offset > 0) {
        this.quill.setSelection(range, Quill.sources.SILENT);
      } else {
        this.quill.setSelection(range.index + row.children.length, range.length, Quill.sources.SILENT);
      }
    }
  }, {
    key: "insertRowAbove",
    value: function insertRowAbove() {
      this.insertRow(0);
    }
  }, {
    key: "insertRowBelow",
    value: function insertRowBelow() {
      this.insertRow(1);
    }
  }, {
    key: "insertTable",
    value: function insertTable(rows, columns) {
      var range = this.quill.getSelection();
      if (range == null) return;
      var delta = new Array(rows).fill(0).reduce(function (memo) {
        var text = new Array(columns).fill('\n').join('');
        return memo.insert(text, {
          table: tableId()
        });
      }, new Delta().retain(range.index));
      this.quill.updateContents(delta, Quill.sources.USER);
      this.quill.setSelection(range.index, Quill.sources.SILENT);
      this.balanceTables();
    }
  }, {
    key: "listenBalanceCells",
    value: function listenBalanceCells() {
      var _this2 = this;

      this.quill.on(Quill.events.SCROLL_OPTIMIZE, function (mutations) {
        mutations.some(function (mutation) {
          if (['TD', 'TR', 'TBODY', 'TABLE'].includes(mutation.target.tagName)) {
            _this2.quill.once(Quill.events.TEXT_CHANGE, function (delta, old, source) {
              if (source !== Quill.sources.USER) return;

              _this2.balanceTables();
            });

            return true;
          }

          return false;
        });
      });
    }
  }]);

  return Table;
}(Module);

export default Table;